/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = NonProcess
 *
 * 1 = Process
 */
export enum ProcessType {
  NonProcess = 0,
  Process = 1,
}
